// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__OFOdO","button-text":"Button_button-text__aF6Zw"};